import type { CrewMember } from "../types/game";

interface Props {
  crew: CrewMember[];
  onCrewClick: (name: string, role: string) => void;
}

const ROLE_ICONS: Record<string, string> = {
  "First Officer": "FO",
  "Helm Officer": "HM",
  "Tactical Officer": "TC",
  "Science Officer": "SC",
  "Communications Officer": "CM",
  "Chief Engineer": "EN",
  "Medical Officer": "MD",
};

function abbreviateName(name: string): string {
  return name
    .replace("Lieutenant Commander", "Lt Cdr")
    .replace("Lieutenant", "Lt")
    .replace("Commander", "Cdr")
    .replace("Ensign", "Ens")
    .replace("Captain", "Cpt");
}

export function CrewPanel({ crew, onCrewClick }: Props) {
  return (
    <div className="crew-panel">
      <div className="panel-header">BRIDGE CREW</div>
      <div className="crew-list">
        {crew.map((member) => (
          <button
            key={member.name}
            className="crew-member"
            onClick={() => onCrewClick(member.name, member.role)}
            title={`Address ${member.name}`}
          >
            <div className="crew-icon">
              {ROLE_ICONS[member.role] || "??"}
            </div>
            <div className="crew-info">
              <div className="crew-name">{abbreviateName(member.name)}</div>
              <div className="crew-role">{member.role}</div>
            </div>
            <div className={`crew-status-dot status-${member.status === "On bridge" ? "active" : "away"}`} />
          </button>
        ))}
      </div>
    </div>
  );
}
